function toCamelCase(str) {
  return str.toLowerCase().replace(/-(.)/g, function(match, group1) {
    return group1.toUpperCase();
  });
}

export class VideoManager {
  constructor() {
    this.overrideNative = true;
    this.options = {
      fill: true,
      muted: false,
      preload: true,
      autoplay: false,
      loop: true,
      controls: true,
      bigPlayButton: false,
      controlBar: true,
      errorDisplay: false,
      html5: {
        vhs: {
          withCredentials: true,
          overrideNative: this.overrideNative,
        },
        nativeVideoTracks: !this.overrideNative,
        nativeAudioTracks: !this.overrideNative,
        nativeTextTracks: !this.overrideNative,
      },
    };

    if (typeof videojs === 'undefined') return;

    this.init();
  }

  init() {
    const videos = document.querySelectorAll('video-js[data-videojs]');

    videos.forEach((video) => {
      const videoId = toCamelCase(video.getAttribute('data-videojs'));
      this[videoId] = videojs(video, this.options, function () {
        // 初期状態の音量設定
        this.volume(1.0);
        return false;
      });

      const videoToggle = document.querySelector(`#${video.getAttribute('data-videojs')}-toggle`);
      if (videoToggle) {
        videoToggle.addEventListener('click', () => {
          if (videoToggle.classList.contains('is-default')) {
            videoToggle.classList.remove('is-default');
          }

          if (this[videoId].paused()) {
            this[videoId].play();
            videoToggle.classList.add('is-playing');
          } else {
            this[videoId].pause();
            videoToggle.classList.remove('is-playing');
          }
        });
      }
    });
  }
}
